var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertOff = function SvgAlertOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.94 4.51c-6.1 0-11.04 4.96-11.04 11.04 0 6.08 4.96 11.04 11.04 11.04 6.08 0 11.04-4.96 11.04-11.04 0-6.08-4.96-11.04-11.04-11.04ZM19.28 41.17a5 5 0 0 0 6.38 3.04c1.42-.5 2.52-1.62 3.04-3.04h-9.42Z",
    fill: "#D64309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.82 28.03c-1.22.38-2.52.58-3.86.58-7.2 0-13.04-5.86-13.04-13.04 0-4.2 2-7.92 5.1-10.32-.32-.02-.64-.06-.96-.06h-.02c-3.28-.02-6.54 1.26-8.92 3.64-2.4 2.36-3.72 5.52-3.74 8.88v8.46c-.04 3.94-1.14 7.8-3.18 11.16l-.92 1.52h33.5l-.92-1.52c-1.72-2.84-2.72-6.02-3.04-9.3Z",
    fill: "#D64309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.726 18.761 3.36-3.36-3.089-3.088 1.596-1.596 3.088 3.089 3.36-3.36 1.714 1.714-3.36 3.36 3.106 3.106-1.595 1.595-3.106-3.106-3.36 3.36-1.714-1.714Z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .51)",
    d: "M0 0h48v48H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .51)",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgAlertOff;